import Input from "ant-design-vue/lib/input"; // 加载 JS
import "ant-design-vue/lib/input/style/css"; // 加载 CSS
import Button from "ant-design-vue/lib/button"; // 加载 JS
import "ant-design-vue/lib/button/style/css"; // 加载 CSS
import Vue from "vue";
Vue.use(Button).use(Input);
const inputMixin = {
  props: {
    field: {},
    fieldValue: "",
    smsType: "",
    fieldResult: {},
    checkFlag: false,
    isPassword: false,
    fieldStyle: {
      type: String,
      default: "style1"
    }
  },
  data() {
    return {
      sendCodeData: {
        timing: null,
        tiem: 60
      },
      fieldObj: {},
      inputValue: this.fieldValue || ""
    };
  },
  watch: {
    checkFlag() {
      this.fieldObj.dirty = true;

      // 手机号需要验证码时 没有输入验证码 提示请输入验证码
      if (this.fieldObj.isSendSms == 1 && !this.fieldObj.verificationCode) {
        this.fieldObj.verificationCodeDirty = true;
      }
      if (this.fieldObj.isSendSms == 1) {
        this.$emit("update:fieldValue", {
          VerifyFail:
            (this.fieldObj.dirty && this.fieldObj.invalid) ||
            (this.fieldObj.verificationCodeDirty &&
              this.fieldObj.verificationCodeError),
          fieldName: this.fieldObj.fieldName,
          checkCode: this.fieldObj.verificationCode,
          value: this.inputValue
        });
      } else {
        this.$emit("update:fieldValue", {
          VerifyFail: this.fieldObj.dirty && this.fieldObj.invalid,
          fieldName: this.fieldObj.fieldName,
          value: this.inputValue
        });
      }

      this.$emit("update:fieldResult", this.fieldObj);
    }
  },
  created() {
    if (this.field.fieldLevel == 4) {
      this.field.errorRequired = "请回答";
    }
    this.fieldObj = new window.$sk.Text(this.field);
    if (this.fieldValue) {
      if (this.fieldObj.isSensitive == 1) {
        this.fieldObj.initValue(this.inputValue);
      } else {
        this.fieldObj.setValue(this.inputValue);
      }
    }
    this.$emit("update:fieldResult", this.fieldObj);
  },
  methods: {
    textChange() {
      this.fieldObj.setValue(this.inputValue);
      this.$emit("change",{
        displayType:this.fieldObj.displayType,
        value: this.inputValue,
        rulesInfo:this.field.rulesInfo,
        rulesCode:this.field.fieldName,
        sortBy:this.field.sortBy
      });
    },
    smsChange() {
      this.fieldObj.setCode(this.fieldObj.verificationCode);
    },
    // 获取验证码
    sendCode() {
      this.fieldObj.sendCode(this.smsType, { tenantId: this.field.tenantId });
    }
  }
};
export default inputMixin;
